module.exports = "<div class=\"ts alerts-container\">\n    <ll-alert ng-repeat=\"alert in alerts\"\n    alert-instance=\"alert\"></ll-alert>\n</div>\n";